import React, { useState, useEffect } from "react";
import axios from "axios";
import Swal from 'sweetalert2';
import { Card, Button, Form, Modal } from "react-bootstrap";
import "../assets/css/Profile.css";
import { baseurl } from '../utility/helper';
import Cropper from "react-easy-crop";

const AdminProfile = () => {
    const adminId = sessionStorage.getItem("adminId");
    const roleid = parseInt(sessionStorage.getItem("userroleId"));
    const [user, setUser] = useState({
        name: "",
        email: "",
        phone: "",
        address: "",
        bio: "",
        profilePicture: "",
    });

    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const [imagePreview, setImagePreview] = useState(null);
    const [profilePic, setProfilePic] = useState(null);
    const [showCropModal, setShowCropModal] = useState(false);
    const [imageToCrop, setImageToCrop] = useState(null);
    const [crop, setCrop] = useState({ x: 0, y: 0 });
    const [zoom, setZoom] = useState(1);
    const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
    const [profilePicFile, setProfilePicFile] = useState(null); // holds the actual File for FormData

    function getCroppedImage(imageSrc, cropPixels) {
    return new Promise((resolve, reject) => {
        const image = new Image();
        image.crossOrigin = "anonymous";
        image.src = imageSrc;
        image.onload = () => {
        const canvas = document.createElement("canvas");
        canvas.width = cropPixels.width;
        canvas.height = cropPixels.height;
        const ctx = canvas.getContext("2d");

        ctx.drawImage(
            image,
            cropPixels.x,
            cropPixels.y,
            cropPixels.width,
            cropPixels.height,
            0,
            0,
            cropPixels.width,
            cropPixels.height
        );

        canvas.toBlob((blob) => {
            if (!blob) {
            reject(new Error("Canvas is empty"));
            return;
            }
            resolve(blob);
        }, "image/jpeg", 0.9);
        };
        image.onerror = (err) => reject(err);
    });
    }

    useEffect(() => {
        fetchProfile();
    }, []);

    const fetchProfile = async () => {
        if (!adminId) {
            console.error("Admin ID not found in session storage.");
            return;
        }

        try {
            const response = await axios.get(`${baseurl}/admin/listadmin/${adminId}`);
            setUser(response.data);
            setProfilePic(response.data.profile_img)
        } catch (error) {
            console.error("Error fetching profile:", error);
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;

        // Validate phone number to be exactly 10 digits
        if (name === "mobileno") {
            const regex = /^[0-9]{0,10}$/; // Regex to allow only numbers and limit to 10 digits
            if (regex.test(value)) {
                setUser ({ ...user, [name]: value });
            }
        } else {
            setUser ({ ...user, [name]: value });
        }
    };

    const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
        const reader = new FileReader();
        reader.onloadend = () => {
        setImageToCrop(reader.result);
        setCrop({ x: 0, y: 0 });
        setZoom(1);
        setShowCropModal(true);
        };
        reader.readAsDataURL(file);
    }
    event.target.value = ""; // allow re-selecting the same file
    };

    const onCropComplete = (_croppedArea, croppedAreaPixelsResult) => {
    setCroppedAreaPixels(croppedAreaPixelsResult);
    };

    const handleCropConfirm = async () => {
    try {
        const croppedBlob = await getCroppedImage(imageToCrop, croppedAreaPixels);
        const croppedFile = new File([croppedBlob], "profile.jpg", { type: "image/jpeg" });

        setProfilePicFile(croppedFile); // this is what gets sent in FormData

        const reader = new FileReader();
        reader.onloadend = () => {
        setProfilePic(reader.result); // preview only
        };
        reader.readAsDataURL(croppedBlob);

        setShowCropModal(false);
        setImageToCrop(null);
    } catch (err) {
        console.error("Error cropping image:", err);
        Swal.fire({
        toast: true, position: "top-end", icon: "error",
        title: "Failed to crop image, please try again.",
        showConfirmButton: false, timer: 2000, timerProgressBar: true
        });
    }
    };

    const handleCropCancel = () => {
    setShowCropModal(false);
    setImageToCrop(null);
    };


    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        const formData = new FormData();
        formData.append("name", user.name);
        formData.append("email", user.email);
        formData.append("mobileno", user.mobileno);
        if (profilePicFile) {
            formData.append("profilePicture", profilePicFile);
        }

        try {
            const token = sessionStorage.getItem("token");
            const response = await axios.put(`${baseurl}/admin/listadmin/${adminId}`, formData, {
                headers: {
                    'Authorization': `${token}`,
                    'Content-Type': 'multipart/form-data'
                }
            });

            Swal.fire({
                            title: 'Success!',
                            text: 'Admin Profile Updated successfully!',
                            icon: 'success',
                            timer: 5000, // Show for 5 seconds
                            timerProgressBar: true,
                            willClose: () => {
                                fetchProfile();
                            }
                        });
            sessionStorage.setItem('username',user.name);
            setUser(response.data);
        } catch (error) {
            console.error("Error updating profile:", error);
            alert("Failed to update profile");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="container mt-4">
            <div className="profile-section">
                <center><h2>Profile</h2></center>
                <div className="row">
                    <div className="col-lg-4">
                        <div className="profile-card-4 z-depth-3">
                            <div className="card">
                                <div className="card-body text-center bg-primary rounded-top">
                                    <div className="user-box">
                                        <img src={profilePic || "https://bootdey.com/img/Content/avatar/avatar7.png"}
                                            alt="add image"
                                            name="images"
                                            className="img-fluid"
                                            style={{ objectFit: "fit-height" }} />
                                    </div>
                                </div>
                                {roleid === 1 && (
                                    <center><h5 className="text" style={{ paddingTop: 10 }}><b>SuperAdmin</b></h5></center>
                                )}
                                {roleid === 2 && (
                                    <center><h5 className="text" style={{ paddingTop: 10 }}><b>{user.chapter_name}</b> Chapter</h5></center>
                                )}
                                {roleid === 3 && (
                                    <center><h5 className="text" style={{ paddingTop: 10 }}><b>{user.chapter_name}</b> Chapter</h5></center>
                                )}
                                {roleid === 4 && (
                                    <center><h5 className="text" style={{ paddingTop: 10 }}><b>{user.chapter_name}</b> Chapter</h5></center>
                                )}
                                {roleid === 5 && (
                                    <center><h5 className="text" style={{ paddingTop: 10 }}><b>{user.chapter_name}</b> Chapter</h5></center>
                                )}
                            </div>
                            <Modal show={showCropModal} onHide={handleCropCancel} backdrop="static" keyboard={false} centered size="md">
                                <Modal.Header closeButton>
                                    <Modal.Title>Crop Your Photo</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    <div style={{ position: "relative", width: "100%", height: "300px", background: "#333" }}>
                                    {imageToCrop && (
                                        <Cropper
                                        image={imageToCrop}
                                        crop={crop}
                                        zoom={zoom}
                                        aspect={1}
                                        onCropChange={setCrop}
                                        onZoomChange={setZoom}
                                        onCropComplete={onCropComplete}
                                        />
                                    )}
                                    </div>
                                    <div className="mt-3">
                                    <label className="form-label">Zoom</label>
                                    <input
                                        type="range"
                                        min={1}
                                        max={3}
                                        step={0.1}
                                        value={zoom}
                                        onChange={(e) => setZoom(Number(e.target.value))}
                                        className="form-range"
                                    />
                                    </div>
                                </Modal.Body>
                                <Modal.Footer>
                                    <Button variant="secondary" onClick={handleCropCancel}>Cancel</Button>
                                    <Button variant="primary" onClick={handleCropConfirm}>Save Crop</Button>
                                </Modal.Footer>
                                </Modal>
                        </div>
                    </div>
                    <div className="col-lg-8">
                        <div className="card z-depth-3">
                            <div className="card-body">
                                <div className="tab-pane" id="edit">
                                    <form onSubmit={handleSubmit}>
                                        <div className="form-group row">
                                            <label className="col-lg-3 col-form-label form-control-label">Full Name</label>
                                            <div className="col-lg-9">
                                                <input className="form-control" type="text" name="name" value={user.name} onChange={handleChange} />
                                            </div>
                                        </div>
                                        <div className="form-group row">
                                            <label className="col-lg-3 col-form-label form-control-label">Email</label>
                                            <div className="col-lg-9">
                                                <input className="form-control" type="email" name="email" value={user.email} onChange={handleChange} readOnly />
                                            </div>
                                        </div>
                                        <div className="form-group row">
                                            <label className="col-lg-3 col-form-label form-control-label">Phone</label>
                                            <div className="col-lg-9">
                                                <input className="form-control" type="telephone" name="mobileno" value={user.mobileno} onChange={handleChange} />
                                            </div>
                                        </div>

                                        {/* Profile Picture Upload */}
                                        <div className="form-group row">
                                            <label className="col-lg-3 col-form-label form-control-label">Profile Picture</label>
                                            <div className="col-lg-9">
                                                <input className="form-control" type="file" accept="image/*" onChange={handleFileChange} />
                                            </div>
                                        </div>

                                        <div className="form-group row">
                                            <div className="col-lg-9 offset-lg-3">
                                                <button type="reset" className="btn btn-secondary">Cancel</button>&nbsp;&nbsp;
                                                <button type="submit" className="btn btn-primary" disabled={loading}>
                                                    {loading ? "Saving..." : "Save Changes"}
                                                </button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AdminProfile;